import { toast } from 'react-toastify';

function hashCode(text) {
  let hash = 0;
  let i;
  let chr;
  for (i = 0; i < text.length; i += 1) {
    chr = text.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

function show(text, type, options) {
  // create toastId
  const toastId = hashCode(text);

  // prevent duplicate message
  if (toast.isActive(toastId)) {
    toast.update(toastId, { autoClose: 3000 });
  } else {
    toast(text, {
      toastId,
      type,
      ...options,
    });
  }
}

function info(text, options) {
  show(text, 'info', options);
}

function success(text, options = {}) {
  show(text, 'success', {
    ...options,
    style: {
      background: 'var(--primary-background-color-light)',
	  color: 'var(--primary-color)',
    },
  });
}

function dark(text, options) {
  show(text, 'dark', options);
}

function error(text, options) {
  show(text, 'error', options);
}

function warn(text, options) {
  show(text, 'warning', options);
}

export default { info, success, dark, error, warn };
